import { createContext, useContext, useEffect, ReactNode, useState, useCallback } from "react";

interface SidebarToggleContextValue {
  isSideBarOpen: boolean;
  toggleSidebar: () => void;
}

const SidebarToggleContext = createContext<SidebarToggleContextValue | undefined>(undefined);

export function SidebarToggleProvider({ children }: { children: ReactNode }) {
  const [isSideBarOpen, setIsSidebarOpen] = useState(true);

  // Auto-close on small screens
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
      }
    };

    // run once initially
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  return (
    <SidebarToggleContext.Provider value={{ isSideBarOpen, toggleSidebar }}>
      {children}
    </SidebarToggleContext.Provider>
  );
}

export function useSidebarToggle() {
  const context = useContext(SidebarToggleContext);
  if (!context)
    throw new Error("useSidebarToggle must be used inside SidebarToggleProvider");
  return context;
}
